import apiLogin from "appRedux/loginApi";
import { handleError } from "appRedux/actions/Common";
import {
  GLOBAL_FETCH_START,
  GLOBAL_FETCH_SUCCESS,
  SUCCESSFUL_CODE,
} from "appRedux/constants";
import _ from "lodash";
import { FETCH_SEARCH_DETAILS_SUCCESS } from "./constant";
import { useOperatorNavigate } from "utils/navigationHelper";

let isFetchSearchLoading = false;

// fallback safe navigation if hook not usable outside React
const navigate =
  (useOperatorNavigate && typeof useOperatorNavigate === "function"
    ? useOperatorNavigate()
    : (path) => {
        if (typeof window !== "undefined") {
          window.location.href = path;
        }
      });

export const getFetchSearchLoading = () => isFetchSearchLoading;

/**
 * fetchSearch
 * @param {Object} options
 * @param {string} options.whitelabel - required operator/whitelabel name
 * @param {boolean} options.canReserve - true => trip search, false => operator routes
 * 
 * --- When canReserve = true (reservable search):
 *   @param {string} options.origin
 *   @param {string} options.destination
 *   @param {string} options.departureDate (YYYY-MM-DD)
 *   @param {string} [options.time] (HH:mm, optional)
 * 
 * --- When canReserve = false (non-reservable search):
 *   @param {string} options.routeType
 *   @param {string} options.routeName
 * 
 * @param {number} [options.page=0]
 * @param {number} [options.pageSize=10]
 */
export const fetchSearch = (options) => {
  return (dispatch) => {
    const {
      whitelabel,
      canReserve,
      origin,
      destination,
      departureDate,
      // time,
      routeType,
      routeName,
      page = 0,
      pageSize = 10,
    } = options || {};

    if (!whitelabel || whitelabel.trim() === "") {
      dispatch(
        handleError("Operator not found. Please contact the administrator.")
      );
      return;
    }

    dispatch({ type: GLOBAL_FETCH_START });
    isFetchSearchLoading = true;

    let url = "";

    if (canReserve) {
      // Trip search
      let query = `whitelabel=${encodeURIComponent(whitelabel)}`;
      if (origin) query += `&origin=${encodeURIComponent(origin)}`;
      if (destination) query += `&destination=${encodeURIComponent(destination)}`;
      if (departureDate) query += `&departureDate=${encodeURIComponent(departureDate)}`;
      // if (time) query += `&time=${encodeURIComponent(time)}`;
      // query += `&page=${page}&pageSize=${pageSize}`;
      url = `/trip/whitelabel/search?${query}`;
    } else {
      // Operator routes search
      let query = `page=${page}&pageSize=${pageSize}&whitelabel=${encodeURIComponent(
        whitelabel
      )}`;
      if (routeType) query += `&type=${encodeURIComponent(routeType)}`;
      if (routeName) query += `&name=${encodeURIComponent(routeName)}`;
      url = `/routes/operator?${query}`;
    }

    apiLogin
      .get(url)
      .then(({ data }) => {
       
        isFetchSearchLoading = false;
        if (data?.status && data.statusCode === SUCCESSFUL_CODE) {
          dispatch({ type: GLOBAL_FETCH_SUCCESS });
          dispatch(fetchSearchSuccess(data.data));
          try {
            navigate("/buy-ticket");
          } catch (e) {
            if (typeof window !== "undefined") window.location.href = "/buy-ticket";
          }
        } else {
          dispatch({ type: GLOBAL_FETCH_SUCCESS });
          dispatch(
            handleError(_.isEmpty(data?.message) ? "Network Error" : data.message)
          );
        }
      })
      .catch((error) => {
        isFetchSearchLoading = false;
        dispatch({ type: GLOBAL_FETCH_SUCCESS });
        dispatch(
          handleError(_.isEmpty(error?.message) ? "Network Error" : error.message)
        );
      });
  };
};

export const fetchSearchSuccess = (data) => ({
  type: FETCH_SEARCH_DETAILS_SUCCESS,
  payload: data,
});
